const getMetaValue = (name) => {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  return element.getAttribute('content');
};

const getRequest = async (url) => {
  try {
    return await request(url);
  } catch (error) {
    throw error;
  }
};

const postRequest = async (url, data) => {
  let body = JSON.stringify(data);
  try {
    return await request(url, { body, method: 'POST' });
  } catch (error) {
    throw error;
  }
};

const deleteRequest = async (url) => {
  try {
    return await request(url, {
      method: 'DELETE',
      headers: { Accept: 'text/html' },
    });
  } catch (error) {
    throw error;
  }
};

const patchRequest = async (url, data) => {
  let body = JSON.stringify(data);
  try {
    return await request(url, { body, method: 'PATCH' });
  } catch (error) {
    throw error;
  }
};

const request = async (url, options = {}) => {
  let headers = {
    'X-CSRF-Token': getMetaValue('csrf-token'),
    'Content-Type': 'application/json',
    Accept: 'text/vnd.turbo-stream.html, application/json',
  };
  if (options.headers) {
    headers = { ...headers, ...options.headers };
    delete options.headers;
  }

  let requestOptions = {
    credentials: 'same-origin',
    headers,
  };
  try {
    return await fetch(url, { ...requestOptions, ...options });
  } catch (error) {
    throw error;
  }
};

const isEmpty = (object) => {
  return Object.keys(object).length == 0;
};

const kebabize = (str) => {
  return str
    .split('')
    .map((letter, idx) => {
      return letter.toUpperCase() === letter
        ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
        : letter;
    })
    .join('');
};

module.exports = {
  postRequest,
  patchRequest,
  deleteRequest,
  getRequest,
  isEmpty,
  kebabize,
};
